import React, { useState, useEffect } from "react";
import axios from "axios";
import image1 from "../assets/image_1.png";  // Default user icon
import image5 from "../assets/homeownersample.jpg";  // Default inside picture

const Accordianlist = () => {
  const [homeowners, setHomeowners] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHomeowners = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get("https://usermanagementsystem-497524552274.us-central1.run.app/admin/get-users-by-role/USER", {
          headers: { "Authorization": `Bearer ${token}` }
        });

        const formattedHomeowners = response.data.usersList.map((user) => ({
          id: user.id,
          Username: user.name || "Unknown",
          Lastname: user.username.split('@')[0],
          email: user.email,
          Mobilenumber: user.phone || "Not provided",  
          Address: user.address || "No address provided",
          City: user.city || "Unknown",
          RegistrationDate: user.registrationDate || "Not available",
          UserType: user.userType || "Regular",
          Status: "Active", 
          icon: image1,
          Insidepic: image5
        }));

        setHomeowners(formattedHomeowners);
      } catch (err) {
        setError("Failed to fetch homeowners. Please try again later.");
      }
    };

    fetchHomeowners();
  }, []);

  const handleApprove = async (id) => {
    console.log(`Approving plumber with ID: ${id}`);
    // You can replace the console log with an API call like:
    // await axios.post(`http://localhost:8080/admin/approve-plumber/${id}`);
  };

  const handleRemove = async (id) => {
    console.log(`Removing plumber with ID: ${id}`);
    // You can replace the console log with an API call like:
    // await axios.delete(`http://localhost:8080/admin/remove-plumber/${id}`);
  };

  return (
    <div style={styles.container}>
      {error && <p style={styles.error}>{error}</p>}
      <h2 style={styles.heading}>Plumber List</h2>
      <ul style={styles.list}>
        {homeowners.length > 0 ? (
          homeowners.map((homeowner, index) => (
            <li key={index} style={styles.listItem}>
              <img src={homeowner.icon || image1} alt="Homeowner" style={styles.image} />
              <div style={styles.details}>
                <h3>{homeowner.Username} {homeowner.Lastname}</h3>
                <p><strong>Status:</strong> {homeowner.Status}</p>
                <p><strong>Email:</strong> {homeowner.email}</p>
                <p><strong>Mobile:</strong> {homeowner.Mobilenumber}</p>
                <p><strong>Address:</strong> {homeowner.Address}</p>
                <p><strong>City:</strong> {homeowner.City}</p>
                <p><strong>Registration Date:</strong> {homeowner.RegistrationDate}</p>
                <p><strong>User Type:</strong> {homeowner.UserType}</p>
                <div style={styles.buttonContainer}>
                  <button style={styles.approveButton} onClick={() => handleApprove(homeowner.id)}>Approve</button>
                  <button style={styles.removeButton} onClick={() => handleRemove(homeowner.id)}>Remove</button>
                </div>
              </div>
              <img src={homeowner.Insidepic || image5} alt="Inside Pic" style={styles.insideImage} />
            </li>
          ))
        ) : (
          <div>No homeowners found</div>
        )}
      </ul>
    </div>
  );
};

// CSS-in-JS styles
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "20px",
  },
  heading: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "20px",
  },
  error: {
    color: "red",
  },
  list: {
    listStyleType: "none",
    padding: 0,
    width: "70%",
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: "1px solid #ddd",
    borderRadius: "10px",
    padding: "15px",
    marginBottom: "15px",
    backgroundColor: "#f8f9fa",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
  },
  image: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    marginRight: "15px",
  },
  insideImage: {
    width: "100px",
    height: "60px",
    borderRadius: "5px",
  },
  details: {
    flexGrow: 1,
    textAlign: "left",
  },
  buttonContainer: {
    display: "flex",
    gap: "10px",
    marginTop: "10px",
  },
  approveButton: {
    backgroundColor: "#28a745",
    color: "white",
    border: "none",
    padding: "8px 12px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  removeButton: {
    backgroundColor: "#dc3545",
    color: "white",
    border: "none",
    padding: "8px 12px",
    borderRadius: "5px",
    cursor: "pointer",
  }
};

export default Accordianlist;
